/**
 * Gallery API
 *
 * API functions for uploading portfolio/gallery images
 */

import { buildApiUrl, handleApiResponse } from '@/src/shared/api';
import { fetchWithTokenRefresh } from '@/src/shared/api/refreshToken';

export interface GalleryUploadResponse {
  url: string;
}

/**
 * Upload a gallery/portfolio image
 * Returns the URL of the uploaded image
 */
export async function uploadGalleryImage(file: File): Promise<GalleryUploadResponse> {
  const url = buildApiUrl('/storage/public/gallery');

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetchWithTokenRefresh(url, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  return handleApiResponse<GalleryUploadResponse>(response);
}
